import { createContext, useContext } from "react";

export interface AddOnLimits {
    /** The API skips limits for a past arrival, so the client does too. */
    isPastDated?: boolean;
    /** Saved line items: a quantity above a limit stays allowed, and only an increase is blocked. */
    shouldAllowSavedQuantity?: boolean;
    guestCount?: number;
    /** Limit error messages, keyed by catalog item id or line item template id. */
    errors?: Record<ID, string>;
    /** A per event limit's catalogItemOpen from the last Reserve, keyed by line item template id. */
    catalogItemOpen?: Record<ID, number>;
    /** Keyed by line item template id. Each flag is sent on that add-on's line item. */
    overrideRestrictions?: Record<ID, boolean>;
    onOverrideRestrictionsChange?: (value: boolean, templateId?: ID) => void;
}

const AddOnLimitsContext = createContext<AddOnLimits>({});

export const AddOnLimitsProvider = AddOnLimitsContext.Provider;

export const useAddOnLimits = () => useContext(AddOnLimitsContext);
